import React from "react";
import { OperationalFormsPage } from "./OperationalFormsPage";
import { operationalFormsHomePage } from "./TrainEventRecord/TrainEventRecordPageSelector";
import './OperationalForms.css'

export const OperationalForms = () => {
    return (
        <>
            <OperationalFormsPage selectedPage={operationalFormsHomePage}>
                <div className="te-list-container">
                    Welcome to Rail Operations!

                    Select the a form on the left side bar to complete and submit.
                </div>
            </OperationalFormsPage>
        
        </>
    );
};